import Cookies from "js-cookie";

export function adminRole() {
  return Cookies.get("cms-admin-role");
}
export function accessDashboard() {
  return Cookies.get("cms-admin-role") === "Super" ||
    (Cookies.get("cms-permissions") &&
      Cookies.get("cms-permissions").includes("dashboard"))
    ? true
    : false;
}
export function accessViewPages() {
  return Cookies.get("cms-admin-role") === "Super" ||
    (Cookies.get("cms-permissions") &&
      Cookies.get("cms-permissions").includes("view pages"))
    ? true
    : false;
}
export function accessAddPages() {
  return Cookies.get("cms-admin-role") === "Super" ||
    (Cookies.get("cms-permissions") &&
      Cookies.get("cms-permissions").includes("create pages"))
    ? true
    : false;
}
export function accessEditPages() {
  return Cookies.get("cms-admin-role") === "Super" ||
    (Cookies.get("cms-permissions") &&
      Cookies.get("cms-permissions").includes("edit pages"))
    ? true
    : false;
}
export function accessDeletePages() {
  return Cookies.get("cms-admin-role") === "Super" ||
    (Cookies.get("cms-permissions") &&
      Cookies.get("cms-permissions").includes("delete pages"))
    ? true
    : false;
}
export function accessViewBlogs() {
  return Cookies.get("cms-admin-role") === "Super" ||
    (Cookies.get("cms-permissions") &&
      Cookies.get("cms-permissions").includes("view blogs"))
    ? true
    : false;
}
export function accessAddBlogs() {
  return Cookies.get("cms-admin-role") === "Super" ||
    (Cookies.get("cms-permissions") &&
      Cookies.get("cms-permissions").includes("create blogs"))
    ? true
    : false;
}
export function accessEditBlogs() {
  return Cookies.get("cms-admin-role") === "Super" ||
    (Cookies.get("cms-permissions") &&
      Cookies.get("cms-permissions").includes("edit blogs"))
    ? true
    : false;
}
export function accessDeleteBlogs() {
  return Cookies.get("cms-admin-role") === "Super" ||
    (Cookies.get("cms-permissions") &&
      Cookies.get("cms-permissions").includes("delete blogs"))
    ? true
    : false;
}
export function accessViewSections() {
  return Cookies.get("cms-admin-role") === "Super" ||
    (Cookies.get("cms-permissions") &&
      Cookies.get("cms-permissions").includes("view sections"))
    ? true
    : false;
}
export function accessAddSections() {
  return Cookies.get("cms-admin-role") === "Super" ||
    (Cookies.get("cms-permissions") &&
      Cookies.get("cms-permissions").includes("create sections"))
    ? true
    : false;
}
export function accessEditSections() {
  return Cookies.get("cms-admin-role") === "Super" ||
    (Cookies.get("cms-permissions") &&
      Cookies.get("cms-permissions").includes("edit sections"))
    ? true
    : false;
}
export function accessDeleteSections() {
  return Cookies.get("cms-admin-role") === "Super" ||
    (Cookies.get("cms-permissions") &&
      Cookies.get("cms-permissions").includes("delete sections"))
    ? true
    : false;
}
export function accessCloneVersion() {
  return Cookies.get("cms-admin-role") === "Super" ||
    (Cookies.get("cms-permissions") &&
      Cookies.get("cms-permissions").includes("clone versions"))
    ? true
    : false;
}
export function accessPublishVersion() {
  return Cookies.get("cms-admin-role") === "Super" ||
    (Cookies.get("cms-permissions") &&
      Cookies.get("cms-permissions").includes("publish versions"))
    ? true
    : false;
}
export function accessUiText() {
  return Cookies.get("cms-admin-role") === "Super" ||
    (Cookies.get("cms-permissions") &&
      Cookies.get("cms-permissions").includes("ui text"))
    ? true
    : false;
}
export function accessNavigation() {
  return Cookies.get("cms-admin-role") === "Super" ||
    (Cookies.get("cms-permissions") &&
      Cookies.get("cms-permissions").includes("navigations"))
    ? true
    : false;
}
export function accessCrm() {
  return Cookies.get("cms-admin-role") === "Super" ||
    (Cookies.get("cms-permissions") &&
      Cookies.get("cms-permissions").includes("crm"))
    ? true
    : false;
}
export function accessSettings() {
  return Cookies.get("cms-admin-role") === "Super" ||
    (Cookies.get("cms-permissions") &&
      Cookies.get("cms-permissions").includes("settings"))
    ? true
    : false;
}
export function capitalizeFirstLetter(string) {
  if (!string) return "";
  return string.charAt(0).toUpperCase() + string.slice(1);
}
